import { useEffect, useState } from "react";
import FileUpload from "../../components/common/FileUpload";
import CustomInput from "../../components/CustomInput";
import CustomSelect from "../../components/CustomSelect";
import { check, close, trash } from "../../asset";
import examsApis from "../../api/ExamsApis";
import { toast } from "sonner";

function FillInBlank({ value, onChange }: any) {
  return (
    <div>
      <CustomInput
        name=""
        label="Correct Answer"
        placeholder="Enter correct answer"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}

function MultipleChoice({ options, setOptions, type }: any) {
  const [newOption, setNewOption] = useState("");
  const [adding, setAdding] = useState(false);

  const confirmAdd = () => {
    if (!newOption.trim()) return;
    setOptions([...options, { text: newOption, correct: false }]);
    setNewOption("");
    setAdding(false);
  };

  const cancelAdd = () => {
    setNewOption("");
    setAdding(false);
  };

  const updateOption = (index: number, key: string, value: any) => {
    const updated = [...options];
    updated[index][key] = value;

    if (key === "correct" && type === "single") {
      updated.forEach((opt, i) => (opt.correct = i === index));
    }

    setOptions(updated);
  };

  const removeOption = (index: number) => {
    const updated = [...options];
    updated.splice(index, 1);
    setOptions(updated);
  };

  return (
    <div className="flex flex-col gap-3">
      {options.length > 0 && (
        <div className="grid grid-cols-3 gap-3 px-2 font-semibold text-sm">
          <div>Delete</div>
          <div>Option Text</div>
          <div>Correct</div>
        </div>
      )}

      {options.map((opt: any, index: number) => (
        <div key={index} className="grid grid-cols-3 gap-3 items-center p-2">
          <div className="flex ">
            <button type="button" onClick={() => removeOption(index)}>
              <img src={trash} alt="" className="w-4 h-4" />
            </button>
          </div>

          <p>{opt.text}</p>

          <div className="flex">
            {type === "single" ? (
              <input
                type="radio"
                name="correct"
                checked={opt.correct}
                onChange={() => updateOption(index, "correct", true)}
              />
            ) : (
              <input
                type="checkbox"
                checked={opt.correct}
                onChange={(e) =>
                  updateOption(index, "correct", e.target.checked)
                }
              />
            )}
          </div>
        </div>
      ))}

      {adding && (
        <div className="items-center p-2 max-w-2xl">
          <div className="flex items-center gap-2">
            <CustomInput
              name=""
              type="text"
              placeholder="enter Option"
              value={newOption}
              onChange={(e) => setNewOption(e.target.value)}
            />
            <button
              onClick={confirmAdd}
              className="bg-success-500 px-4 py-2 rounded-lg"
            >
              <img className="w-7 h-7" src={check} alt="" />
            </button>

            <button
              onClick={cancelAdd}
              className="bg-error-500 px-4 py-2 rounded-lg"
            >
              <img className="w-7 h-7" src={close} alt="" />
            </button>
          </div>
        </div>
      )}

      {!adding && (
        <button
          className="px-3 py-2 bg-primary-500 text-white rounded-full w-fit text-xs"
          type="button"
          onClick={() => setAdding(true)}
        >
          + Add Option
        </button>
      )}
    </div>
  );
}

function JumbledOptions({ list, setList }: any) {
  const add = () => {
    setList([...list, { text: "", position: list.length + 1 }]);
  };

  const update = (i: number, key: string, value: any) => {
    const arr = [...list];
    arr[i][key] = value;
    setList(arr);
  };

  const remove = (i: number) => {
    const arr = [...list];
    arr.splice(i, 1);

    // Reassign positions
    arr.forEach((o, i) => (o.position = i + 1));

    setList(arr);
  };

  return (
    <div className="flex flex-col gap-3">
      {list.map((opt: any, i: number) => (
        <div
          key={i}
          className="grid grid-cols-3 gap-3 items-center p-2 rounded"
        >
          <button type="button" onClick={() => remove(i)}>
            <img src={trash} alt="" className="w-4 h-4" />
          </button>

          <input
            type="text"
            className="border rounded px-2 py-1 text-sm"
            placeholder="Item text"
            value={opt.text}
            onChange={(e) => update(i, "text", e.target.value)}
          />

          <select
            className="border px-2 py-1 rounded text-sm"
            value={opt.position}
            onChange={(e) => update(i, "position", Number(e.target.value))}
          >
            {list.map((_, idx) => (
              <option key={idx} value={idx + 1}>
                {idx + 1}
              </option>
            ))}
          </select>
        </div>
      ))}

      <button
        className="px-3 py-2 bg-primary-500 text-white rounded-full w-fit text-xs"
        type="button"
        onClick={add}
      >
        + Add Item
      </button>
    </div>
  );
}

function MatchPairs({ pairs, setPairs }: any) {
  const add = () => setPairs([...pairs, { left: "", right: "" }]);

  const update = (i: number, key: string, value: any) => {
    const arr = [...pairs];
    arr[i][key] = value;
    setPairs(arr);
  };

  const remove = (i: number) => {
    const arr = [...pairs];
    arr.splice(i, 1);
    setPairs(arr);
  };

  return (
    <div className="flex flex-col gap-3">
      {pairs.map((pair: any, i: number) => (
        <div
          key={i}
          className="grid grid-cols-3 gap-3 items-center border p-2 rounded"
        >
          <button type="button" onClick={() => remove(i)}>
            <img src={trash} alt="" className="w-4 h-4" />
          </button>

          <input
            type="text"
            className="border rounded px-2 py-1 text-sm"
            placeholder="Left"
            value={pair.left}
            onChange={(e) => update(i, "left", e.target.value)}
          />
          <input
            type="text"
            className="border rounded px-2 py-1 text-sm"
            placeholder="Right"
            value={pair.right}
            onChange={(e) => update(i, "right", e.target.value)}
          />
        </div>
      ))}

      <button
        className="px-3 py-2 bg-primary-500 text-white rounded-full w-fit text-xs"
        type="button"
        onClick={add}
      >
        + Add Pair
      </button>
    </div>
  );
}

// -------------------- Main Component -------------------- //

interface QuestionFormProps {
  onSave: (data: any) => void;
  onCancel: () => void;
  sectionId: number;
  editQuestion?: any | null;
}

export default function QuestionForm({
  onSave,
  onCancel,
  sectionId,
  editQuestion,
}: QuestionFormProps) {
  const [type, setType] = useState("");
  const [marks, setMarks] = useState("");
  const [title, setTitle] = useState("");

  const [fillAnswer, setFillAnswer] = useState("");
  const [mcqOptions, setMcqOptions] = useState<any[]>([]);
  const [jumble, setJumble] = useState<any[]>([]);
  const [pairs, setPairs] = useState<any[]>([]);
  const [longAnswer, setLongAnswer] = useState("");

  const types = [
    "single choice from list of options",
    "multi select from list of options",
    "Fill in the blanks",
    "Arrange the following",
    "Match the following",
    "Long Answers",
  ];

  const QUESTION_TYPE_MAP: Record<string, string> = {
    "Fill in the blanks": "SINGLE_LINE_ANSWER",
    "single choice from list of options": "SINGLE_CHOICE",
    "multi select from list of options": "MULTI_CHOICE",
    "Arrange the following": "ARRANGE",
    "Match the following": "MATCH",
    "Long Answers": "LONG_ANSWER",
  };

  const handleClose = () => {
    onCancel();
  };

  useEffect(() => {
    if (editQuestion) {
      setTitle(editQuestion.questionName);
      setMarks(String(editQuestion.marks));
      setType(
        Object.keys(QUESTION_TYPE_MAP).find(
          (k) => QUESTION_TYPE_MAP[k] === editQuestion.questionType
        ) || ""
      );
    }
  }, [editQuestion]);

  const handleSave = async () => {
    if (!type || !marks || !title) {
      toast.error("Please fill all required fields");
      return;
    }

    let options: string[] = [];

    if (
      type === "single choice from list of options" ||
      type === "multi select from list of options"
    ) {
      options = mcqOptions.map((o) => o.text);
    }

    const payload = {
      questionName: title,
      marks: Number(marks),
      question: title,
      isMandatory: true,
      options,
      questionType: QUESTION_TYPE_MAP[type],
    };

    if (editQuestion) {
      if (!editQuestion.questionId && !editQuestion.id) {
        return;
      }
      await examsApis.updateQuestion(editQuestion.questionId, payload);
    } else {
      await examsApis.addQuestion(sectionId, payload);
    }
    onSave(sectionId)
  };

  return (
    <div className="max-w-4xl mx-auto flex flex-col gap-5 pb-10">
      <h3 className="text-base text-neutral-400 font-semibold">Add Question</h3>

      <form className="grid gap-4 px-4">
        <div className="flex flex-wrap lg:flex-nowrap gap-4">
          <div className="flex-1">
            <CustomSelect
              name=""
              label="Question answer type"
              placeholder="select"
              options={types}
              value={type}
              onChange={(e: any) => {
                setType(e.target.value);
                // reset type-specific states
                setMcqOptions([]);
                setJumble([]);
                setPairs([]);
                setFillAnswer("");
                setLongAnswer("");
              }}
            />
          </div>

          <div className="lg:w-72">
            <CustomInput
              name=""
              label="Marks"
              placeholder="Enter max marks"
              value={marks}
              onChange={(e: any) => setMarks(e.target.value)}
            />
          </div>
        </div>

        <CustomInput
          name=""
          label="Question title"
          placeholder="Enter the question..."
          isTextarea
          value={title}
          onChange={(e: any) => setTitle(e.target.value)}
        />

        <div className="flex max-w-xl max-h-20 justify-between">
          <FileUpload
            label="Add Attachment"
            onUploadComplete={() => {}}
            showDropzone={false}
            buttonColor="bg-primary-800"
            buttonText="Choose file"
          />
          <FileUpload
            label="Add Image"
            onUploadComplete={() => {}}
            showDropzone={false}
            buttonColor="bg-success-800"
            buttonText="Choose image"
          />
        </div>

        {type === "Fill in the blanks" && (
          <FillInBlank value={fillAnswer} setValue={setFillAnswer} />
        )}

        {type === "single choice from list of options" && (
          <MultipleChoice
            options={mcqOptions}
            setOptions={setMcqOptions}
            type="single"
          />
        )}

        {type === "multi select from list of options" && (
          <MultipleChoice
            options={mcqOptions}
            setOptions={setMcqOptions}
            type="multiple"
          />
        )}

        {type === "Arrange the following" && (
          <JumbledOptions list={jumble} setList={setJumble} />
        )}

        {type === "Match the following" && (
          <MatchPairs pairs={pairs} setPairs={setPairs} />
        )}

        {type === "Long Answers" && (
          <CustomInput
            name=""
            isTextarea
            label="Correct Answer"
            placeholder="Enter detailed answer..."
            value={longAnswer}
            onChange={(e: any) => setLongAnswer(e.target.value)}
          />
        )}

        {/* Action Buttons */}
        <div className="flex justify-end gap-2 text-xs">
          <button
            type="button"
            onClick={handleSave}
            className="bg-primary-500 rounded-full px-4 py-2 text-white"
          >
            Save
          </button>
          <button
            type="button"
            onClick={handleClose}
            className="bg-neutral-200 text-white rounded-full px-4 py-2"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}
